/**
 * Auto-generated by yarn cross-type:gen-typescript. Do not edit by hand.
 *
 * @source dashboard/lib/shared/braze/remote_lookup/providers/app_remote_lookup_provider.rb
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/app_remote_lookup_provider.rb) */
export const filtersTypeSchema = z.strictObject({
  platform_types: z
    .array(
      z.enum([
        "android",
        "android_china",
        "ios",
        "kepler",
        "kindle",
        "landing_page",
        "roku",
        "tvos",
        "web",
        "windows8",
      ])
    )
    .nullable()
    .optional(),
});

/** @see [ruby definition](../../../../../../../../lib/shared/braze/remote_lookup/providers/app_remote_lookup_provider.rb) */
export const filtersTypeOutputSchema = z.object({
  platform_types: z.array(
    z.enum([
      "android",
      "android_china",
      "ios",
      "kepler",
      "kindle",
      "landing_page",
      "roku",
      "tvos",
      "web",
      "windows8",
    ])
  ),
});
